import { render, staticRenderFns } from "./write-paragraph-kid.vue?vue&type=template&id=2f07697a&scoped=true"
import script from "./write-paragraph-kid.vue?vue&type=script&lang=js"
export * from "./write-paragraph-kid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f07697a",
  null
  
)

export default component.exports